import React, { FC } from "react";
import clsx from "clsx";

import styles from "./ToggleSwitch.module.scss";

export type Props = {
  id: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (checked: boolean) => void;

  // a11y
  "aria-label"?: string;
};

const ToggleSwitch: FC<Props> = ({
  id,
  checked,
  disabled = false,
  className,
  onChange,
  "aria-label": ariaLabel = "toggle",
}) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(!checked);
  };

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleClick}
      className={clsx(
        styles.toggleSwitch,
        checked ? styles.isOn : styles.isOff,
        disabled && styles.isDisabled,
        className,
      )}
    >
      <span className={styles.track} aria-hidden="true">
        <span className={styles.thumb} aria-hidden="true" />
      </span>
    </button>
  );
};

export default ToggleSwitch;
